import {
  Avatar,
  Badge,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  NavbarItem,
} from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { Fragment } from 'react';
import { useCashRegisterContext } from '@hooks/useCashRegisterContext';
import { useAuthContext } from '@/hooks/useAuthContext';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import Logo from '@commons/logo';
import { useSettingContext } from '@/hooks/useSettingContext';
import buildingIcon from '@iconify/icons-mdi/building';

type Props = {
  isNav: boolean;
};
export const User = ({ isNav }: Props) => {
  const { setting, logoBs64 } = useSettingContext();
  const { logout, user } = useAuthContext();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { isOpen } = useCashRegisterContext();

  const name = user?.displayName ?? user?.email?.split('@')[0];

  const handleLogout = async () => {
    try {
      logout();
      navigate('/auth/login', { replace: true });
      // handleClosePopover();
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };
  const TypeContainer = isNav ? NavbarItem : Fragment;
  return (
    <TypeContainer className="px-2">
      <Dropdown placement="bottom-end">
        <DropdownTrigger>
          <Button
            isIconOnly
            variant="light"
            className="mt-1 transition-transform hover:rounded-full"
          >
            <Avatar
              className="transition-transform"
              color={isOpen ? 'success' : 'danger'}
              size="sm"
              src={user?.photoURL ?? setting?.logo ?? ''}
              isBordered
            />
          </Button>
          {/* <button className="mt-1 h-8 w-8 transition-transform"> */}
          {/*   <Badge color="success" content="" placement="bottom-right" shape="circle"> */}
          {/*     <Avatar size="sm" src="https://i.pravatar.cc/150?u=a04258114e29526708c" /> */}
          {/*   </Badge> */}
          {/* </button> */}
        </DropdownTrigger>
        <DropdownMenu aria-label="Profile Actions" variant="flat" style={{ padding: '16px' }}>
          <DropdownItem>
            <p className="text-medium font-semibold">{name}</p>
            <p className="text-xs font-light">{user?.role?.name}</p>
          </DropdownItem>
          <DropdownItem className="">
            <div className="flex flex-row justify-start gap-2 items-center">
              <Icon icon="mdi-source-branch" style={{ fontSize: '18px', color: 'black' }} />
              <p className="text-xs font-light">{user?.branchSelected?.name}</p>
            </div>
          </DropdownItem>
          <DropdownItem className="">
            <div className="flex flex-row justify-start gap-2 items-center">
              <Icon icon={buildingIcon} style={{ fontSize: '18px', color: 'black' }} />
              <p className="text-xs font-light">{user?.companySelected?.name}</p>
            </div>
          </DropdownItem>
          <DropdownItem
            key="divider"
            className="py-[1px]"
            style={{ height: 1, pointerEvents: 'none', backgroundColor: '#eaeaea' }}
          />
          <DropdownItem key="settings" color="primary">
            Profile
          </DropdownItem>

          <DropdownItem key="logout" onClick={handleLogout} color="danger">
            Log Out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </TypeContainer>
  );
};
